/*
 * Copyright Mimic Networks, Inc. 2024.
 */

import { Grid } from 'antd';
import { Outlet } from 'react-router-dom';

import { SupportFooter } from '@/components/SupportFooter';
import { Col } from '@/primitives/Col';

import { Layout } from './primitives/Layout';

const { useBreakpoint } = Grid;

export function CenterLayout() {
  const screens = useBreakpoint();

  return (
    <Layout height="auto">
      <Col
        style={{
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
        }}
      >
        <Col
          style={{
            flex: '1',
            display: 'flex',
            flexDirection: 'column',
            boxSizing: 'border-box',
            paddingTop: screens.sm ? '5vh' : '15vh',
            paddingBottom: '5vh',
          }}
        >
          <div
            style={{
              margin: screens.sm ? 'auto' : '0 auto',
              width: 'fit-content',
              maxWidth: '100%',
            }}
          >
            <Outlet />
          </div>
        </Col>
        <SupportFooter />
      </Col>
    </Layout>
  );
}
